import { createContext } from 'react';
import type { LoginRequest, User } from '@/types/auth';

/**
 * Auth context value
 */
export interface AuthContextValue {
  /**
   * The signed-in user, or null
   */
  user: User | null;

  /**
   * Whether a user is signed in
   */
  isAuthenticated: boolean;

  /**
   * True only while the stored session is being restored on startup.
   * Login/logout do not toggle it (forms track their own submitting state).
   */
  isInitializing: boolean;

  /**
   * Login with email and password; rejects with an ApiError on failure
   */
  login: (credentials: LoginRequest) => Promise<void>;

  /**
   * Logout the current user (never rejects)
   */
  logout: () => Promise<void>;
}

/**
 * Auth context. Undefined outside AuthProvider so useAuth can detect misuse.
 * Lives in its own (non-component) module for React Fast Refresh.
 */
export const AuthContext = createContext<AuthContextValue | undefined>(undefined);
